import { config } from 'config'

const openCustomDeepLink = (url) => {
  const queryParamIndex = url.indexOf('?')
  const queryParam = url.substring(queryParamIndex)
  const deepLinkUrl = `${config.app.scheme}://${config.app.screen_name}${queryParam}`

  window.location.assign(deepLinkUrl)

  setTimeout(() => {
    window.close()
  }, 100)
}

const openDeepLink = (page, query) => {
  window.location.assign(`${config.app.scheme}://${page}?${query}`)

  setTimeout(() => {
    window.close()
  }, 100)
}

export { openDeepLink, openCustomDeepLink }
